import { useEffect } from "react";
//
//component
//redux
//selector
//actions
const TriggerKeyboard = ({ togglePlay }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    const handleKeyDown = (event) => {
      // 1. Kiểm tra phím Space (dùng event.code để chính xác nhất)
      const isSpace = event.code === "Space";

      // 2. Kiểm tra phím bổ trợ:
      // metaKey là phím Command (Mac), ctrlKey là phím Control (Windows/Linux)
      const isModifierPressed = event.shiftKey;

      if (isModifierPressed && isSpace) {
        // 3. Ngăn chặn hành động mặc định của trình duyệt/hệ thống
        event.preventDefault();

        // --- THỰC HIỆN LOGIC CỦA BẠN TẠI ĐÂY ---
        return togglePlay();
      }
    };

    // Đăng ký sự kiện trên đối tượng window
    window.addEventListener("keydown", handleKeyDown);

    // Cleanup function để xóa sự kiện khi component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [togglePlay]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerKeyboard;
